"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconArea = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 24 24",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M7,5 L9,5 L9,3 L7,3 L7,5 Z M7,21 L9,21 L9,19 L7,19 L7,21 Z M11,21 L13,21 L13,19 L11,19 L11,21 Z M3,21 L5,21 L5,19 L3,19 L3,21 Z M3,17 L5,17 L5,15 L3,15 L3,17 Z M3,13 L5,13 L5,11 L3,11 L3,13 Z M3,9 L5,9 L5,7 L3,7 L3,9 Z M3,5 L5,5 L5,3 L3,3 L3,5 Z M19,17 L21,17 L21,15 L19,15 L19,17 Z M19,13 L21,13 L21,11 L19,11 L19,13 Z M19,21 L21,21 L21,19 L19,19 L19,21 Z M19,9 L21,9 L21,7 L19,7 L19,9 Z M19,3 L19,5 L21,5 L21,3 L19,3 Z M11,5 L13,5 L13,3 L11,3 L11,5 Z M15,21 L17,21 L17,19 L15,19 L15,21 Z M15,5 L17,5 L17,3 L15,3 L15,5 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconArea')(IconArea);